import { render, staticRenderFns } from "./GenerateCOE.vue?vue&type=template&id=0808972c&scoped=true"
import script from "./GenerateCOE.vue?vue&type=script&lang=js"
export * from "./GenerateCOE.vue?vue&type=script&lang=js"
import style0 from "./GenerateCOE.vue?vue&type=style&index=0&id=0808972c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0808972c",
  null
  
)

export default component.exports